(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["first-shopper-popup"] && !Shopify.designMode) return;
  try {
    
  const popups = document.querySelectorAll('[data-samira-popup]');

  popups.forEach((popup) => {
    const storageKey = `samira-popup-dismissed-v2-${popup.dataset.sectionId}`;
    const submittedKey = `samira-popup-submitted-${popup.dataset.sectionId}`;
    const delay = Number(popup.dataset.delay || 2500);
    const frequencyDays = Number(popup.dataset.frequency || 7);
    const lastDismissed = Number(window.localStorage.getItem(storageKey) || 0);
    const waitWindow = frequencyDays * 24 * 60 * 60 * 1000;
    const submittedFromPopup = window.sessionStorage.getItem(submittedKey) === 'true';
    const canShow = submittedFromPopup || !lastDismissed || Date.now() - lastDismissed > waitWindow;

    const closePopup = () => {
      popup.setAttribute('hidden', '');
      window.localStorage.setItem(storageKey, String(Date.now()));
    };

    if (submittedFromPopup) {
      window.sessionStorage.removeItem(submittedKey);
      window.localStorage.removeItem(storageKey);
      popup.removeAttribute('hidden');

      const form = popup.querySelector('form');
      const success = document.createElement('p');
      success.className = 'samira-popup__success';
      success.tabIndex = -1;
      success.textContent = popup.dataset.successMessage || 'You’re on the list. Check your inbox for your checkout code.';

      if (form && !popup.querySelector('[data-samira-popup-js-success]')) {
        success.setAttribute('data-samira-popup-js-success', '');
        form.insertAdjacentElement('afterend', success);
      }

      window.requestAnimationFrame(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        success.focus({ preventScroll: true });
      });
    } else if (canShow) {
      window.setTimeout(() => {
        popup.removeAttribute('hidden');
        const emailInput = popup.querySelector('input[type="email"]');
        if (emailInput) {
          emailInput.focus({ preventScroll: true });
        }
      }, delay);
    }

    const form = popup.querySelector('form');
    const phoneInput = popup.querySelector('[data-samira-popup-phone]');
    const tagsInput = popup.querySelector('[data-samira-popup-tags]');
    const smsConsentInput = popup.querySelector('[data-samira-popup-sms-consent]');

    if (form && phoneInput && tagsInput) {
      form.addEventListener('submit', (event) => {
        const baseTags = 'newsletter, first-time-shopper, popup, welcome-discount';
        const hasPhone = Boolean(phoneInput.value.trim());
        const smsOptedIn = Boolean(smsConsentInput && smsConsentInput.checked);

        if (hasPhone && smsConsentInput && !smsOptedIn) {
          event.preventDefault();
          smsConsentInput.focus();
          window.alert('Please check the text-message permission box, or leave the phone number blank.');
          return;
        }

        tagsInput.value = hasPhone && smsOptedIn ? `${baseTags}, sms-opt-in` : baseTags;
        window.sessionStorage.setItem(submittedKey, 'true');
      });
    }

    popup.querySelectorAll('[data-samira-popup-close]').forEach((button) => {
      button.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !popup.hasAttribute('hidden')) {
        closePopup();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('[data-samira-menu-close]').forEach((button) => {
    button.addEventListener('click', () => {
      const drawer = button.closest('details');
      if (drawer) {
        drawer.removeAttribute('open');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
